import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { loadPageData } from "../../actions";
import StatementFormFlagOff from "./StatementFormFlagOff";
import Loader from "../Common/Loader";
import Footer from "../Footer";
import { Nav, NavWithComponent } from "../Nav";
import { FeatureFlags, useFeatures } from "../../providers/features-provider";
import { HeaderCustomer } from "@payright/web-components";
import StatementForm from "./StatementForm";

const Statements = () => {
  const { flagsConfig } = useFeatures();

  const statementsFlag = flagsConfig[FeatureFlags.STATEMENTS_REDO];

  const dispatch = useDispatch();

  const { customer } = useSelector<RootState, { customer: any }>((state) => ({
    customer: state.pageData.customer,
  }));

  useEffect(() => {
    if (customer === null) {
      dispatch(loadPageData());
    }
  }, [dispatch, customer]);

  if (!customer) {
    return <Loader text="Fetching customer details..." />;
  }

  if (!statementsFlag) {
    return (
      <div>
        <NavWithComponent title="Your Statement" activePage="/my-plans" />
        <StatementFormFlagOff />
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <div className="customer-navigation">
        <Nav activePage="/my-plans" />
        <HeaderCustomer title="Your Statement" />
        <StatementForm />
      </div>
      <Footer />
    </div>
  );
};

export default Statements;
